import WelcomeLayout from '@/layouts/Welcome';

export default function PrivateWelcomeLayoutRoute() {
  return <WelcomeLayout />;
}
